import { ContentBlockType, SimpleCalloutBlock, SimpleCalloutVariant } from '../../../model';

export const DEFAULT_SIMPLE_CALLOUT_PROPS = {
  title: 'Callout',
  variant: SimpleCalloutVariant.Concept,
  type: ContentBlockType.SimpleCallout,
  content: [],
} as const satisfies Partial<SimpleCalloutBlock>;
